import { format, setDate } from 'date-fns'

/**
 * Formats a day-of-month number as its ordinal word form: 1 -> "1st", 2 -> "2nd", 23 -> "23rd".
 * Used for recurring monthly dates ("rent is due on the 1st"), where only the day matters and
 * there is no real calendar date to format.
 */
export const formatDayOfMonthOrdinal = (day: number): string =>
  format(setDate(new Date(2000, 0, 1), day), 'do')
